import * as React from "react";
import { Container, Box } from "@mui/material";
import { FormProvider } from "./page/context";
import { SignupForm } from "./page";
import "./index.css";
import { TermsCondition } from "./page/components/terms-conditions";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <Box
      display={"flex"}
      alignItems={"flex-start"}
      justifyContent={"center"}
      sx={{ overflowX: "hidden", overflowY: "auto" }}
      height={"100vh"}
      width={"100vw"}
    >
      <Box sx={{ width: 670 }}>
        <Container
          maxWidth="md"
          id="main_container"
          style={{ paddingLeft: "40px", paddingRight: "40px" }}
        >
          <Box sx={{ pt: 4, pb: 4 }}>
            <FormProvider>
              <BrowserRouter>
                <Routes>
                  <Route index element={<SignupForm />} />
                  <Route path="termsconditions" element={<TermsCondition />} />
                </Routes>
              </BrowserRouter>
            </FormProvider>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}

export default App;
